<template>
  <div class="file-info flex" v-if="item.type == 4 && item.obj">
    <img class="file-info__icon" :src="getIcon(item.obj?.name)" alt="" />
    <div class="flex flex-column flex-center flex-between flex-1">
      <div class="file-info__name">{{ item.obj?.name }}</div>
      <div class="flex flex-between flex-item-center">
        <div class="file-info__size">{{ sizeFilter(item.obj?.size) }}</div>
        <i style="font-size: 13px" class="iconfont icon-download" @click="downloadFile(item)" />
      </div>
    </div>
    <div class="file-info__load" v-if="item.obj.url === ''">
      <i class="iconfont icon-loading" />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { sizeFilter, downloadFile } from '@/utils/index'
const props = defineProps({
  item: { type: Object, default: () => {} }
})
// 获取文件Icon
const getIcon = (filename) => {
  let suffix = filename.split('.')?.pop()
  if ('pdf'.includes(suffix)) {
    return require('@/assets/images/pdf.png')
  } else if ('ppt,pptx'.includes(suffix)) {
    return require('@/assets/images/ppt.png')
  } else if ('txt'.includes(suffix)) {
    return require('@/assets/images/txt.png')
  } else if ('xls,xlsx'.includes(suffix)) {
    return require('@/assets/images/xls.png')
  } else if ('doc,docx'.includes(suffix)) {
    return require('@/assets/images/doc.png')
  }
}
</script>

<style lang="less" scoped>
.file-info {
  font-size: 12px;
  text-align: left;
  position: relative;
  &__icon {
    width: 42px;
    height: 42px;
    margin-right: 6px;
  }
  &__name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    width: 100%;
    max-width: 150px;
  }
  &__size {
    color: #999;
  }
  &__load {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.5);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    > i {
      font-size: 24px;
    }
  }
}
</style>
